import type { FC, PropsWithChildren } from 'react';
import styles from './price-wrapper.module.css';

export const PriceWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};
